/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Backup_Not_ConfiguredInputs */



/**
* | output |
* | --- |
* | "Automatic backup not configured or there were issues saving your backup project." |
*
* @param {Automatic_Save_Backup_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_backup_not_configured = /** @type {((inputs?: Automatic_Save_Backup_Not_ConfiguredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Backup_Not_ConfiguredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sauvegarde automatique non configurée ou problème lors de l’enregistrement du projet de sauvegarde.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die automatische Datensicherung ist nicht konfiguriert oder es gab Probleme beim Speichern Ihres Sicherungsprojekts.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Backup automatico non configurato oppure si sono verificati problemi durante il salvataggio del progetto di backup.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое резервное копирование не настроено или возникли проблемы при сохранении проекта резервной копии.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La copia de seguridad automática no está configurada o hubo problemas al guardar el proyecto de copia de seguridad.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动备份未配置，或者保存备份项目时出现问题。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップが構成されていないか、バックアップ プロジェクトの保存中に問題が発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप कॉन्फ़िगर नहीं किया गया है या आपके बैकअप प्रोजेक्ट को सहेजने में समस्याएँ थीं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O backup automático não está configurado ou ocorreram problemas ao salvar seu projeto de backup.")
	return /** @type {LocalizedString} */ ("Automatic backup not configured or there were issues saving your backup project.")
});